import MetaTags from "../MetaTags";
import Logo from "../../images/BONJOURNO_LOGO.png";
import { getPublicAppUrl, normalizePublicUrl } from "../../utils/publicUrl";
import { buildPublicPageStructuredData, PUBLIC_SITE_PAGES } from "../../utils/publicSiteMetadata";

export default function PublicSiteMeta({ page, faqs }) {
  const metadata = PUBLIC_SITE_PAGES[page];
  const url = getPublicAppUrl(metadata.path);
  const image = normalizePublicUrl(Logo.src || Logo);

  return <MetaTags title={metadata.title} description={metadata.description}
    url={url} canonicalUrl={url} siteName="BonJourno"
    image={image} imageAlt="BonJourno logo" imageWidth={965} imageHeight={359}
    structuredData={buildPublicPageStructuredData(page, { url, logoUrl: image, faqs })} />;
}
